import { DiagnoseService } from './../../../../../Service/DiagnoseService';
import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { DiagnoseFragmentComponent } from './DiagnoseFragmentComponent';

/**
 * DiagnoseFragmentController
 * 検査結果一覧画面のコントローラー
 */
export class DiagnoseFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: DiagnoseFragmentComponent;

	/**
	 * getDiagnoseList
	 * 検査結果のリストを取得
	 * @returns 検査結果のリスト
	 */
	public async getDiagnoseList(param: { view: any }) {

		const svc = new DiagnoseService(param.view);
		const ret = await svc.getDiagnoseList();

		return ret;

	}

}

